import { render } from "./admin-layout.vue?vue&type=template&id=c537f682&scoped=true"
import script from "./admin-layout.js?vue&type=script&lang=js&external"
export * from "./admin-layout.js?vue&type=script&lang=js&external"

import "./admin-layout.css?vue&type=style&index=0&id=c537f682&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c537f682"]])

export default __exports__